<template>
  <base-modal :modal-id="modalId">
    <!--<template v-slot:header>
      &lt;!&ndash;<button
          type="button"
          class="d-sm-none btn btn-arrow"
          data-dismiss="modal"
          @click="$bvModal.hide(modalId)"
      >
        <img src="/images/svg/global/left_arrow.svg" />
      </button>&ndash;&gt;
      &lt;!&ndash;<h4 class="modal-title mb-0 d-sm-none">{{ _T('Loyalty') }}</h4>
      <h4 class="modal-title mb-0 d-none d-sm-block">
        {{ _T('Loyalty') }}
      </h4>
      <hr/>&ndash;&gt;
    </template>-->
    <template v-if="domainBasedBrand" v-slot:modal-body>
      <div class="loyalty_star">
        <img src="/img/loyalty_star.svg" />
      </div>
      <!--<div v-if="loyalty_validation_information.amount">{{ Num.price(loyalty_validation_information.amount) }}</div>-->
      <div v-if="loyalty && !loyalty_validation_information.msg">
        <p class="txt_center_margin_auto">{{ _T('You can spend ') }} {{ Num.price(max_loyalty_spent, undefined, 3) }} {{ _T(' maximum loyalty') }}</p>
        <hr/>
        <form class="default-form row txt_center_margin_auto">
          <div class="form-group col-lg-8">{{ _T('How much loyalty you want to spend') }}</div>
          <div class="form-group col-lg-4">
            <input
                type="text"
                class="form-control"
                :placeholder="Num.price(max_loyalty_spent, undefined, 3)"
                v-model="user_change_loyalty"
            />
          </div>
        </form>
      </div>
      <p class="validation_error" v-if="loyalty_validation_information.msg">{{ _T (loyalty_validation_information.msg) }}</p>

    </template>
    <template v-else v-slot:modal-body>
      <div class="loyalty_star">
        <img src="/img/loyalty_star.svg" />
      </div>
      <!--<div v-if="loyalty_validation_information.amount">{{ Num.price(loyalty_validation_information.amount) }}</div>-->
      <div v-if="loyalty">
        <p class="txt_center_margin_auto">{{ _T('You can spend ') }} {{ Num.price(cashback_balance, undefined, 3) }} {{ _T(' maximum loyalty') }}</p>
        <hr/>
        <form class="default-form row txt_center_margin_auto">
          <div class="form-group col-lg-8">{{ _T('How much loyalty you want to spend') }}</div>
          <div class="form-group col-lg-4">
            <input
                type="text"
                class="form-control"
                :placeholder="Num.price(cashback_balance, undefined, 3)"
                v-model="user_change_loyalty"
            />
          </div>
        </form>
      </div>
      <p class="validation_error" v-if="loyalty_validation_information.msg">{{ _T (loyalty_validation_information.msg) }}</p>

    </template>
    <hr />
    <template v-slot:modal-footer>
      <div class="btn-action">
        <button
            type="button"
            class="btn btn-danger cancel-announce color-text-invert color-button"
            data-dismiss="modal"
            @click="$bvModal.hide(modalId)"
        >
          {{ _T('Close') }}
        </button>
        &nbsp;
        <button
            class="btn btn-success btn-large popup-btn-save color-text-invert color-main"
            type="button"
            id="gift-card-btn"
            data-toggle="modal"
            data-dismiss="modal"
            @click="payByLoyalty"
            v-if="loyalty && !loyalty_validation_information.msg"
        >
          {{ _T('Add') }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import { mapGetters } from 'vuex'
import { Num } from '@/helpers/Math.js'

export default {
  name: 'LoyaltyInformation',
  components: {
    BaseModal,
  },
  computed: {
    ...mapGetters(['_T',
      'loyalty_validation_information',
      'domainBasedBrand',
      'loyalty_spent',
      'max_loyalty_spent',
      'cashback_balance',
      'exchange_price',
      'reverse_exchange_price',
      'currentBrand']),
    /*user_change_loyalty: {
      get() {
        return this.$store.state.payment_store.user_change_loyalty
      },
      set(val) {
        this.$store.commit('USER_CHANGE_LOYALTY', val)
      },
    },*/
  },
  methods:{
    payByLoyalty() {
      let user_applied_loyalty_conversion = this.reverse_exchange_price(this.user_change_loyalty)
      let loyalty_exchange_price = this.exchange_price(this.max_loyalty_spent)
      let minimum_redeem_exchange = this.exchange_price(this.currentBrand.minimum_redeem)
      if (!this.domainBasedBrand) {
        if (parseFloat(this.cashback_balance) < parseFloat(this.user_change_loyalty)) {
          let loyalty_info = { msg: 'You can not add more then ' + Num.round(this.cashback_balance, 3) + ' loyalty', amount: 0}
          this.$store.commit('LOYALTY_INFORMATION', loyalty_info)
        } else {
          this.$store.commit('USER_CHANGE_LOYALTY', user_applied_loyalty_conversion)
          this.$bvModal.hide(this.modalId)
        }
      } else {
        if (parseFloat(minimum_redeem_exchange) > parseFloat(this.user_change_loyalty)) {
          let loyalty_info = { msg: 'Please add more then ' + minimum_redeem_exchange + ' loyalty', amount: 0}
          this.$store.commit('LOYALTY_INFORMATION', loyalty_info)
        }
        else if (parseFloat(loyalty_exchange_price) >= parseFloat(this.user_change_loyalty)) {
          this.$store.commit('USER_CHANGE_LOYALTY', user_applied_loyalty_conversion)
          // this.$store.commit('CASHBACK_ON_TRANSACTION', this.user_change_loyalty)
          this.$bvModal.hide(this.modalId)
        } else {
          let loyalty_info = { msg: 'You can not add more then ' + Num.round(loyalty_exchange_price, 3) + ' loyalty', amount: 0}
          this.$store.commit('LOYALTY_INFORMATION', loyalty_info)
        }
      }
    }
  },
  props: {
    loyalty: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      process: 'change-password',
      modalId: 'loyalty-information',
      user_change_loyalty: 0,
    }
  },
}
</script>

<style lang="scss" scoped>
/*.body-rtl {
  .modal-body {
      .btns {
        text-align: left;
        .btn {
          + .btn {
            margin-right: $px8;
            margin-left: unset;
          }
        }
      }

      label {
        text-align: right;
        float: right;
      }
    }
}*/
.loyalty_star {
  text-align: center;
  img {
    width: 60px;
    border-radius: 100%;
    box-shadow: 0 4px 10px rgba(252, 124, 63, 0.85);
  }
  margin-bottom: 20px;
}

.btn-action {
  display: -ms-inline-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px
}
.txt_center_margin_auto {
  text-align: center;
  margin:auto;
}
input.form-control {
  border: none;
  border-bottom: 1px solid;
  height: 10px !important;
  margin:auto

}
.validation_error {
  text-align: center;
  color: #f10808;
}
</style>
